import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  FormGroup,
  ControlLabel,
  FormControl,
  Checkbox,
} from 'react-bootstrap'
import MEModal from '../../components/MEModal'

export const AddPeopleModal = props => {
  const [enforceAccessDefault, setEnforceAccess] = React.useState(true)
  const [requirePurchase, setRequirePurchase] = React.useState(true)

  const checkEnforceAccess = () => {
    props.handleEnforceAccessDays(!enforceAccessDefault)
    setEnforceAccess(!enforceAccessDefault)
  }

  const requirePurchaseSelection = e => {
    props.handlePaymentRecordSelection(e)
    setRequirePurchase(!requirePurchase)
  }

  const extraFormFields = (
    <Fragment>
      <FormGroup controlId="formControlsPaymentRecordSelect">
        <ControlLabel>Create Payment Record</ControlLabel>
        <FormControl
          componentClass="select"
          placeholder="select"
          onChange={e => requirePurchaseSelection(e)}
        >
          <option value="no">
            No. Require student(s) to purchase the book.
          </option>
          <option value="yes">
            Yes. Student(s) do not need to purchase the book.
          </option>
        </FormControl>
      </FormGroup>
      {props.daysOfAccess > 0 && !requirePurchase && (
        <FormGroup controlId="formControlsEnforceDaysCheck">
          <Checkbox
            inline
            onChange={checkEnforceAccess}
            checked={enforceAccessDefault}
          >
            Enforce {props.daysOfAccess} Days of Access
          </Checkbox>
        </FormGroup>
      )}
      <FormGroup controlId="formControlsNotifySelect">
        <ControlLabel>Course Member Notification</ControlLabel>
        <FormControl
          componentClass="select"
          placeholder="select"
          onChange={props.handleNotificationSelection}
        >
          <option value="no">No. Do not email anyone.</option>
          <option value="yes">Yes. Email the people who were added.</option>
        </FormControl>
      </FormGroup>
    </Fragment>
  )
  return (
    <MEModal
      show={props.showAddPeopleModal}
      close={props.toggleAddPeopleModal}
      title="Add / Edit People"
    >
      <p>
        Enter/paste email address, first name, last name, student ID (optional)
        as shown in the box below, one person per line.
      </p>
      <p>
        If a given email address already exists in the system, the existing user
        will be added to the course. Otherwise, a new user account will be
        created with a temporary password and added to the course.
      </p>
      <p>
        Student IDs, if present, will always be updated.
      </p>
      <FormGroup controlId="formControlsTextArea">
        <ControlLabel>
          Email Address, First Name, Last Name, Student ID (optional)
        </ControlLabel>
        <FormControl
          componentClass="textarea"
          placeholder="john_doe@university.edu, John, Doe, 12345"
          onChange={props.handlePeopleInfoChange}
        />
      </FormGroup>
      <FormGroup controlId="formControlsRoleSelect">
        <ControlLabel>Role</ControlLabel>
        <FormControl
          componentClass="select"
          placeholder="select"
          onChange={props.handleRoleSelectionChange}
        >
          <option value="student">Student</option>
          <option value="mentor">Mentor</option>
          <option value="assistant">Teaching Assistant</option>
          <option value="instructor">Instructor</option>
          {props.elevatedUser ? <option value="manager">Manager</option> : null}
        </FormControl>
      </FormGroup>
      <FormGroup controlId="formControlsSectionSelect">
        <ControlLabel>Section</ControlLabel>
        <FormControl
          componentClass="select"
          placeholder="select"
          onChange={props.handleSectionSelection}
        >
          {props.sections.map((x, key) => {
            return (
              <option key={key} value={x.secName}>
                {x.secName}
              </option>
            )
          })}
        </FormControl>
      </FormGroup>
      {props.elevatedUser ? extraFormFields : null}
      <Button
        type="submit"
        bsStyle="primary"
        className="btn-myed btn-primary-myed"
        onClick={props.handleFormSubmit}
      >
        Submit
      </Button>
      <Button
        type="button"
        bsStyle="default"
        className="btn-myed btn-default-myed"
        onClick={props.toggleAddPeopleModal}
      >
        Cancel
      </Button>
    </MEModal>
  )
}

AddPeopleModal.propTypes = {
  showAddPeopleModal: PropTypes.bool,
  toggleAddPeopleModal: PropTypes.func,
  handlePeopleInfoChange: PropTypes.func,
  handleRoleSelectionChange: PropTypes.func,
  handleSectionSelection: PropTypes.func,
  handlePaymentRecordSelection: PropTypes.func,
  handleNotificationSelection: PropTypes.func,
  handleFormSubmit: PropTypes.func,
  sections: PropTypes.array,
  elevatedUser: PropTypes.bool,
  daysOfAccess: PropTypes.number,
  handleEnforceAccessDays: PropTypes.func,
}
